<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  selectedPlan: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['confirm']);

const { t } = useI18n();

const dialogRef = ref(null);

const handleDialogConfirm = () => {
  emit('confirm');
  dialogRef.value?.close();
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('CAMPAIGN_PLANS.DELETE.TITLE')"
    :description="t('CAMPAIGN_PLANS.DELETE.DESCRIPTION')"
    :confirm-button-label="t('CAMPAIGN_PLANS.DELETE.CONFIRM')"
    @confirm="handleDialogConfirm"
  />
</template>

